import { atom } from "jotai";

export const managersAtom = atom([]);
export const isLoadingManagersAtom = atom(false);
